import {
  ActionButton,
  InformativeTag,
  Label,
  List,
  ListItem,
  MainButton
} from '@icarros/ids-react';
import {
  CardBody,
  CardButtonWrapper,
  CardInformative,
  CardListActions,
  CardSupport,
  ListItemModifier,
  TagLayout,
  TagWrapper
} from './style';
import { LISTING, OFFERS, PERFORMANCE } from '../../../../../utils/routes';
import React, { useState } from 'react';
import {
  formatFabricationAndModelYear,
  formatPriceToReal,
  formatTimeFrom,
  removePlural
} from '../../../../utils/formatters';

import { CardOptions } from './CardOptions';
import { CardProps } from './constants';
import { getFirstImage } from '../../../../utils/getFirstImage';
import { pushSellerPFDashboardEvent } from '../../../../../utils/pushToDataLayer';
import { url } from '../../../../utils/url';
import { useHistory } from 'react-router-dom';
import { useRenewAd } from '../../../../hooks/useRenewAd';
import { useWebappFlags } from '../../../../hooks/useWebAppFlags';

const SHARE_BUTTON_STATES = {
  waiting: {
    name: 'Compartilhar',
    icon: 'itaufonts_compartilhar'
  },
  copied: {
    name: 'Link copiado',
    icon: 'itaufonts_check'
  }
};

export function Active({ card }: Readonly<CardProps>): JSX.Element {
  const { renewMutation } = useRenewAd(card.id);
  const [shareState, setShareState] = useState<'waiting' | 'copied'>('waiting');
  const { getFlagOnSession } = useWebappFlags();

  const history = useHistory();

  function handleShareClick() {
    pushSellerPFDashboardEvent(SHARE_BUTTON_STATES[shareState].name);
    navigator.clipboard.writeText(
      `Confira o carro que estou anunciando no icarros.\n${url.format
        .toShareableDetailsPage(String(card.id))
        ?.toString()}`
    );
    setShareState('copied');
    setTimeout(() => {
      setShareState('waiting');
    }, 3000);
  }

  return (
    <>
      <div>
        <img src={getFirstImage(card.fotos)} alt="Primeira imagem do anuncio" />
      </div>
      <CardBody>
        <CardSupport showCopiedFeedback={shareState == 'copied'}>
          <CardInformative>
            {card.filterText && (
              <InformativeTag variant="outlined" type="success">
                {removePlural(card.filterText)}
              </InformativeTag>
            )}
            {card.dataPublicacao && (
              <Label variant="neutral" size="xsmall">
                {formatTimeFrom(card.dataPublicacao, 'long', true)}
              </Label>
            )}
          </CardInformative>
          <div>
            {card.link ? (
              <ActionButton
                iconName={SHARE_BUTTON_STATES[shareState].icon}
                text={SHARE_BUTTON_STATES[shareState].name}
                variant="secondary"
                weight="medium"
                onClick={handleShareClick}
              />
            ) : (
              <></>
            )}
            <CardOptions editId={card.id} linkToAd={card.link} showDeactivate showHelp showEdit />
          </div>
        </CardSupport>
        <List>
          <ListItemModifier>
            <ListItem
              label={`${card.veiculo.marca.nome} ${card.veiculo.modelo.nome}`}
              subLabel={`${card.veiculo.versao.nome} ${formatFabricationAndModelYear(
                card.veiculo.anoFabricacao,
                card.veiculo.anoModelo
              )}`}
              variant="action"
              actionOnClick={() => {
                pushSellerPFDashboardEvent('>');
                history.push(`${LISTING}/${card.id}`);
              }}
            />
          </ListItemModifier>
        </List>
        <TagLayout>
          <Label size="medium" variant="neutral" weight="bold">
            {formatPriceToReal(card.valorVenda)}
          </Label>
          {card.chassiVerificado?.status && getFlagOnSession('validacaoChassi') && (
            <TagWrapper>
              <InformativeTag type="success" contrast="light" variant="outlined">
                Placa e chassi verificados
              </InformativeTag>
            </TagWrapper>
          )}
        </TagLayout>
        <CardListActions>
          <List>
            <ListItem
              avatarIcon="itaufonts_mercado_noticias"
              avatarVariant="icon"
              label="Acessar performance"
              variant="action"
              actionOnClick={() => {
                pushSellerPFDashboardEvent('Acessar performance');
                history.push(`${LISTING}/${card.id}${PERFORMANCE}`);
              }}
            />
            <ListItem
              avatarIcon="itaufonts_sms_mensagem_chat"
              avatarVariant="icon"
              label="Acessar mensagens"
              variant="action"
              actionOnClick={() => {
                pushSellerPFDashboardEvent('Acessar mensagens');
                history.push(`${OFFERS}/${card.id}`);
              }}
            />
          </List>
          <CardButtonWrapper>
            <MainButton
              text="Editar"
              variant="primary"
              iconName="itaufonts_seta_right"
              onClick={() => {
                pushSellerPFDashboardEvent('editar anúncio');
                history.push(`${LISTING}/${card.id}`);
              }}
            />

            {card.podeRenovar && (
              <MainButton
                text="Renovar"
                isLoading={renewMutation.isLoading}
                iconName="itaufonts_seta_right"
                onClick={() => {
                  pushSellerPFDashboardEvent('Reativar');
                  renewMutation.mutate();
                }}
              />
            )}
          </CardButtonWrapper>
        </CardListActions>
      </CardBody>
    </>
  );
}
